"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEmailRecommendation = void 0;
var _upsellSelectors = require("../../store/upsell/upsellSelectors");
var _useRecommendationCosts = require("../recommendation/useRecommendationCosts");
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _useAppSelector = require("../useAppSelector");
const useEmailRecommendation = () => {
  const selectedHandset = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedHandsetVariant);
  const selectedPlan = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedPlanVariant);
  const selectedUpsellingProducts = (0, _useAppSelector.useAppSelector)(_upsellSelectors.selectSelectedUpsellProductOfferings);
  const selectedBroadband = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedBroadbandVariant);
  const selectedBusinessSolution = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedBusinessSolutionVariant);
  const selectedConnectivityPlan = (0, _useAppSelector.useAppSelector)(_upsellSelectors.selectConnectivityPlan);
  const {
    totalTermCost,
    totalUpfrontCost
  } = (0, _useRecommendationCosts.useRecommendationCosts)();
  return {
    selectedHandset,
    selectedPlan,
    selectedUpsellingProducts,
    selectedBroadband,
    selectedBusinessSolution,
    totalTermCost,
    totalUpfrontCost,
    selectedConnectivityPlan
  };
};
exports.useEmailRecommendation = useEmailRecommendation;